import styled from 'styled-components';

type SpacerProps = {
  width?: number;
  height?: number;
};

const Spacer = styled.div<SpacerProps>`
  width: ${(p) => (p.width ? p.width : 4)}px;
  height: ${(p) => (p.height ? p.height : 4)}px;
`;

export default Spacer;
